import { createBrowserRouter, RouterProvider, createRoutesFromElements, Route, Navigate } from 'react-router-dom'
import { ToastProvider } from './components/ui/Toast'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import ErrorBoundary from './components/ErrorBoundary'
import Layout from './components/Layout'
import LoginPage from './pages/LoginPage'
import ProductCreatorPage from './pages/ProductCreatorPage'
import ProductOptimizerPage from './pages/ProductOptimizerPage'
import ProductsPage from './pages/ProductsPage'
import CalculatePricesPage from './pages/CalculatePricesPage'
import CategoryCreatorPage from './pages/CategoryCreatorPage'
import CategoryOptimizerPage from './pages/CategoryOptimizerPage'
import CategoryImageUploadPage from './pages/CategoryImageUploadPage'
import CustomersDashboardPage from './pages/CustomersDashboardPage'
import CarriersPage from './pages/CarriersPage'
import ShippingPage from './pages/ShippingPage'
import ShippingRulesPage from './pages/ShippingRulesPage'
import DashboardPage from './pages/DashboardPage'
import BusinessBrainPage from './pages/BusinessBrainPage'
import PricingConfigPage from './pages/PricingConfigPage'
import PriceHistoryPage from './pages/PriceHistoryPage'
import ConfigurationPage from './pages/ConfigurationPage'
import StockMinimumPage from './pages/StockMinimumPage'
import FactusolPage from './pages/FactusolPage'
import SyncPage from './pages/SyncPage'
import InvoicesPage from './pages/InvoicesPage'
import ManualInvoicePage from './pages/ManualInvoicePage'
import SchedulerPage from './pages/SchedulerPage'
import ApiClientsPage from './pages/ApiClientsPage'
import SupplierCatalogsPage from './pages/SupplierCatalogsPage'
import SupplierPortalAdminPage from './pages/SupplierPortalAdminPage'
import ProductVariantsPage from './pages/ProductVariantsPage'
import FreeShippingPage from './pages/FreeShippingPage'
import ShippingCostsPage from './pages/ShippingCostsPage'
import ReembolsosPage from './pages/ReembolsosPage'
import WeightConfigPage from './pages/WeightConfigPage'
import UsersPage from './pages/UsersPage'
import MarketingPage from './pages/MarketingPage'
import WhatsAppPage from './pages/WhatsAppPage'
import GoogleAdsPage from './pages/GoogleAdsPage'
import GoogleMerchantPage from './pages/GoogleMerchantPage'
import GoogleAdsProductsPage from './pages/GoogleAdsProductsPage'
import GoogleAdsCampaignsPage from './pages/GoogleAdsCampaignsPage'
import GoogleAdsAudiencesPage from './pages/GoogleAdsAudiencesPage'
import GoogleAdsOptimizerPage from './pages/GoogleAdsOptimizerPage'
import SuppliersConfigPage from './pages/SuppliersConfigPage'
import ProductsListPage from './pages/ProductsListPage'
import ProductQueuePage from './pages/ProductQueuePage'
import ProductImagesPage from './pages/ProductImagesPage'
import SeoAnalyticsPage from './pages/SeoAnalyticsPage'
import ReportsSupplierOrdersPage from './pages/ReportsSupplierOrdersPage'
import ProfitReportPage from './pages/ProfitReportPage'
import NetProfitPage from './pages/NetProfitPage'
import AsesoriaExportPage from './pages/AsesoriaExportPage'
import ExpensesPage from './pages/ExpensesPage'
import BusinessValuePage from './pages/BusinessValuePage'
import TransportReportPage from './pages/TransportReportPage'
import EmailPromosPage from './pages/EmailPromosPage'
import B2BLotsPage from './pages/B2BLotsPage'
import EmailManagementPage from './pages/EmailManagementPage'
import EbayPage from './pages/EbayPage'
import ReturnsPage from './pages/ReturnsPage'
import IncidentsPage from './pages/IncidentsPage'
import RepairsPage from './pages/RepairsPage'
import PublicReturnsPage from './pages/PublicReturnsPage'
import PublicReturnTrackingPage from './pages/PublicReturnTrackingPage'
import ReturnPaymentPage, { ReturnPaymentOkPage, ReturnPaymentKoPage } from './pages/ReturnPaymentPage'
import PublicRepairRequestPage from './pages/PublicRepairRequestPage'
import PublicRepairTrackingPage from './pages/PublicRepairTrackingPage'
import RepairsLandingPage from './pages/RepairsLandingPage'
import RepairPaymentPage, { RepairPaymentOkPage, RepairPaymentKoPage } from './pages/RepairPaymentPage'
import FeedbackPage from './pages/FeedbackPage'
import StockAlertsPage from './pages/StockAlertsPage'
import SupplierPortalPage from './pages/SupplierPortalPage'

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      {/* Ruta pública de login */}
      <Route path="/login" element={<LoginPage />} />

      {/* Rutas públicas de devoluciones */}
      <Route path="/returns" element={<PublicReturnsPage />} />
      <Route path="/returns/track/:code" element={<PublicReturnTrackingPage />} />
      <Route path="/returns/track" element={<PublicReturnTrackingPage />} />
      <Route path="/returns/pay/:code/ok" element={<ReturnPaymentOkPage />} />
      <Route path="/returns/pay/:code/ko" element={<ReturnPaymentKoPage />} />
      <Route path="/returns/pay/:code/:feeId/:token" element={<ReturnPaymentPage />} />

      {/* Landing pública SEO/SEM (campañas marketing) */}
      <Route path="/reparacion-portatiles-cantabria" element={<RepairsLandingPage />} />

      {/* Rutas públicas de reparaciones */}
      <Route path="/repairs" element={<PublicRepairRequestPage />} />
      <Route path="/repairs/track/:code" element={<PublicRepairTrackingPage />} />
      <Route path="/repairs/track" element={<PublicRepairTrackingPage />} />
      <Route path="/repairs/pay/:code/:token" element={<RepairPaymentPage />} />
      <Route path="/repairs/pay/:code/ok" element={<RepairPaymentOkPage />} />
      <Route path="/repairs/pay/:code/ko" element={<RepairPaymentKoPage />} />

      {/* Ruta pública de feedback (review gate) */}
      <Route path="/feedback" element={<FeedbackPage />} />

      {/* Portal externo de proveedores asiáticos (suppliers.jvs-app.es) */}
      <Route path="/supplier-portal" element={<SupplierPortalPage />} />

      {/* Rutas protegidas */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route
          path="dashboard"
          element={
            <ProtectedRoute requiredPermission="dashboard">
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="cerebro"
          element={
            <ProtectedRoute requiredPermission="brain">
              <BusinessBrainPage />
            </ProtectedRoute>
          }
        />
        <Route path="products">
          <Route
            index
            element={
              <ProtectedRoute requiredPermission="products">
                <ProductsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="list"
            element={
              <ProtectedRoute requiredPermission="products">
                <ProductsListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="create"
            element={
              <ProtectedRoute requiredPermission="products.create">
                <ProductCreatorPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="queue"
            element={
              <ProtectedRoute requiredPermission="products.create">
                <ProductQueuePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="optimizer"
            element={
              <ProtectedRoute requiredPermission="products.optimize">
                <ProductOptimizerPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="calculate-prices"
            element={
              <ProtectedRoute requiredPermission="products.prices">
                <CalculatePricesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="category/create"
            element={
              <ProtectedRoute requiredPermission="products.categories">
                <CategoryCreatorPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="category/optimizer"
            element={
              <ProtectedRoute requiredPermission="products.categories">
                <CategoryOptimizerPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="category/image"
            element={
              <ProtectedRoute requiredPermission="products.categories">
                <CategoryImageUploadPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="images"
            element={
              <ProtectedRoute requiredPermission="products">
                <ProductImagesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="variants"
            element={
              <ProtectedRoute requiredPermission="products.variants">
                <ProductVariantsPage />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route
          path="supplier-catalogs"
          element={
            <ProtectedRoute requiredPermission="products.catalogs">
              <SupplierCatalogsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="supplier-portal-admin"
          element={
            <ProtectedRoute requiredPermission="products.catalogs">
              <SupplierPortalAdminPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="customers"
          element={
            <ProtectedRoute requiredPermission="commercial.customers">
              <CustomersDashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="commercial/waitlist"
          element={
            <ProtectedRoute requiredPermission="commercial.waitlist">
              <StockAlertsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="invoices"
          element={
            <ProtectedRoute requiredPermission="commercial.invoices">
              <InvoicesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="invoices/manual"
          element={
            <ProtectedRoute requiredPermission="commercial.invoices">
              <ManualInvoicePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="marketing"
          element={
            <ProtectedRoute requiredPermission="commercial.marketing">
              <MarketingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="email-management"
          element={
            <ProtectedRoute requiredPermission="commercial.marketing">
              <EmailManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="email-promos"
          element={
            <ProtectedRoute requiredPermission="commercial.marketing">
              <EmailPromosPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="b2b-lots"
          element={
            <ProtectedRoute requiredPermission="commercial.b2b_lots">
              <B2BLotsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="whatsapp"
          element={
            <ProtectedRoute requiredPermission="commercial.marketing">
              <WhatsAppPage />
            </ProtectedRoute>
          }
        />
        <Route path="google-ads">
          <Route
            index
            element={
              <ProtectedRoute requiredPermission="commercial.marketing">
                <GoogleAdsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="products"
            element={
              <ProtectedRoute requiredPermission="commercial.marketing">
                <GoogleAdsProductsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="campaigns"
            element={
              <ProtectedRoute requiredPermission="commercial.marketing">
                <GoogleAdsCampaignsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="audiences"
            element={
              <ProtectedRoute requiredPermission="commercial.marketing">
                <GoogleAdsAudiencesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="optimizer"
            element={
              <ProtectedRoute requiredPermission="commercial.marketing">
                <GoogleAdsOptimizerPage />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route
          path="google-merchant"
          element={
            <ProtectedRoute requiredPermission="commercial.marketing">
              <GoogleMerchantPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="ebay"
          element={
            <ProtectedRoute requiredPermission="commercial.ebay">
              <EbayPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="carriers"
          element={
            <ProtectedRoute requiredPermission="logistics.carriers">
              <CarriersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="shipping"
          element={
            <ProtectedRoute requiredPermission="logistics.shipping">
              <ShippingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="returns-admin"
          element={
            <ProtectedRoute requiredPermission="logistics.returns">
              <ReturnsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="repairs-admin"
          element={
            <ProtectedRoute requiredPermission="logistics.repairs">
              <RepairsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="incidents"
          element={
            <ProtectedRoute requiredPermission="logistics.incidents">
              <IncidentsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="shipping-rules"
          element={
            <ProtectedRoute requiredPermission="logistics.shipping">
              <ShippingRulesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="free-shipping"
          element={
            <ProtectedRoute requiredPermission="logistics.freeshipping">
              <FreeShippingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="shipping-costs"
          element={
            <ProtectedRoute requiredPermission="logistics.shipping">
              <ShippingCostsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="reembolsos"
          element={
            <ProtectedRoute requiredPermission="logistics.reembolsos">
              <ReembolsosPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="weight-config"
          element={
            <ProtectedRoute requiredPermission="logistics.shipping">
              <WeightConfigPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="sync"
          element={
            <ProtectedRoute requiredPermission="integrations.sync">
              <SyncPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="api-clients"
          element={
            <ProtectedRoute requiredPermission="integrations.api">
              <ApiClientsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="scheduler"
          element={
            <ProtectedRoute requiredPermission="integrations.scheduler">
              <SchedulerPage />
            </ProtectedRoute>
          }
        />
        <Route path="configuration">
          <Route index element={<Navigate to="/configuration/families" replace />} />
          <Route
            path="families"
            element={
              <ProtectedRoute requiredPermission="configuration.families">
                <ConfigurationPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="suppliers"
            element={
              <ProtectedRoute requiredPermission="configuration.suppliers">
                <SuppliersConfigPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="stock-minimum"
            element={
              <ProtectedRoute requiredPermission="configuration.stock">
                <StockMinimumPage />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route
          path="pricing"
          element={
            <ProtectedRoute requiredPermission="products.prices">
              <PricingConfigPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="price-history"
          element={
            <ProtectedRoute requiredPermission="products.prices">
              <PriceHistoryPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="factusol"
          element={
            <ProtectedRoute requiredPermission="integrations.sync">
              <FactusolPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="users"
          element={
            <ProtectedRoute requiredPermission="admin.users">
              <UsersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="seo-analytics"
          element={
            <ProtectedRoute requiredPermission="commercial.marketing">
              <SeoAnalyticsPage />
            </ProtectedRoute>
          }
        />
        <Route path="reports">
          <Route index element={<Navigate to="/reports/supplier-orders" replace />} />
          <Route
            path="supplier-orders"
            element={
              <ProtectedRoute requiredPermission="reports.supplier_orders">
                <ReportsSupplierOrdersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="profit"
            element={
              <ProtectedRoute requiredPermission="reports.profit">
                <ProfitReportPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="net-profit"
            element={
              <ProtectedRoute requiredPermission="reports.profit">
                <NetProfitPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="expenses"
            element={
              <ProtectedRoute requiredPermission="reports.profit">
                <ExpensesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="valor"
            element={
              <ProtectedRoute requiredPermission="reports.profit">
                <BusinessValuePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="transporte"
            element={
              <ProtectedRoute requiredPermission="reports.profit">
                <TransportReportPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="asesoria"
            element={
              <ProtectedRoute requiredPermission="reports.profit">
                <AsesoriaExportPage />
              </ProtectedRoute>
            }
          />
        </Route>
      </Route>
    </>
  )
)

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </AuthProvider>
    </ErrorBoundary>
  )
}

export default App
